import { useState, useEffect } from 'react';
import { formatNowMexicoCityLabel } from '../lib/clinicTime';

export { CLINIC_TIMEZONE } from '../lib/clinicTime';

/**
 * Reloj en vivo (cada segundo) en hora de la clínica (America/Mexico_City).
 */
export function useMexicoCityClock() {
  const [value, setValue] = useState(() => formatNowMexicoCityLabel());

  useEffect(() => {
    const tick = () => setValue(formatNowMexicoCityLabel());
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);

  return value;
}
